export default "__VITE_ASSET__k1O$IDN6__"